var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowBack = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20711 0.542893C9.59763 0.933417 9.59763 1.56658 9.20711 1.95711L4.16421 7H18.25C18.8023 7 19.25 7.44772 19.25 8C19.25 8.55228 18.8023 9 18.25 9H4.16421L9.20711 14.0429C9.59763 14.4334 9.59763 15.0666 9.20711 15.4571C8.81658 15.8476 8.18342 15.8476 7.79289 15.4571L1.04289 8.70711C0.652369 8.31658 0.652369 7.68342 1.04289 7.29289L7.79289 0.542893C8.18342 0.152369 8.81658 0.152369 9.20711 0.542893Z",
    fill: "#AFAFAF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_back.e98cc1026ef6aada46dd4a7398d8c8a4.svg";